import { Grid } from '@mui/system';
// import { Button } from '@mui/material';
import React, { useRef } from 'react';
import Slider from 'react-slick';
// import arrow from '../../../assets/svg/arrowSmall.svg';
// import mobilbg from '../../../assets/svg/growthbg.svg';
import SliderButton from '../../../components/SliderButton/SliderButton';

function Growth({ growthSection }) {
  const sliderRef = useRef(null);
  const settings = {
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    variableWidth: false,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          centerPadding: '0px',
          infinite: true,
          slidesToShow: 1.95,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          swipeToSlide: true,
        },
      },
    ],
  };
  return (
    <Grid
      className="growth-section"
      sx={{
        justifyContent: 'center',
        backgroundImage: { xs: 'linear-gradient(to bottom, #AEC3B0 50%, #ffffff 50%)', md: `url(${growthSection?.backgroundImage?.url}), linear-gradient(to right, #D0DBD0, #77A47B)` },
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',

      }}>
      <Grid
        container
        sx={{
          justifyContent: 'space-between',
        }}
        className="section-top">
        <Grid size={{ xs: 12, md: 3 }} mt={{ sm: 0, md: 7 }} mb={{ sm: 3, md: 0 }}>
          <div>
            <h4 className="box-subtitle">
              {growthSection.title}
            </h4>
            <h2 className="box-title" dangerouslySetInnerHTML={{ __html: growthSection.subTitle }} />
            <Grid
              container
              size={{ xs: 12 }}
              alignItems={'center'}
              sx={{
                paddingTop: '12px',
                paddingBottom: '40px',
                gap: '12px',
                display: { sm: 'none' },
              }}>
              <SliderButton size="24px" onClick={() => sliderRef.current.slickPrev()} />
              <SliderButton isNext size="24px" onClick={() => sliderRef.current.slickNext()} />
            </Grid>
          </div>
        </Grid>

        <Grid size={{ xs: 12, md: 9 }}>
          <Slider ref={sliderRef} {...settings}>
            {growthSection?.cardList?.slice(0, 4).map((item) => (
              <Grid
                size={{ xs: 6, md: 3 }}
                spacing={2}
                key={item.id}>
                <div style={{ margin: '4px 16px 4px 0px' }}>
                  <div className="growth-card-wrap">
                    <div className="card-content">
                      <img alt="icon" className="card-icon" src={`${item?.icon?.url}`} />
                      <div className="title">{item.title}</div>
                      <div className="subTitle">{item.subTitle}</div>
                      {/* <Button
                        fullWidth
                        style={{ display: 'flex !important' }}
                        sx={{
                          mt: '16px',
                          fontFamily: ' Lato',
                          fontSize: '12px',
                          lineHeight: ' 18px',
                          color: '#01161E',
                          textTransform: 'none',
                        }}
                        endIcon={<img alt="" src={arrow} height={'13px'} />}
                        >
                        {item?.buttonLabel?.slice(0, 25)}
                      </Button> */}
                    </div>
                  </div>
                </div>
              </Grid>
            ))}
          </Slider>
        </Grid>
      </Grid>
      <Grid />
    </Grid>

  );
}

export default Growth;
